
<ng-container *ngIf="{
    row: columnData | async
  } as $">
<a class="text-primary" href="javascript:void(0)" (click)="OpenPaymentDetails($.row)">{{$.row.number_prefix }}{{$.row.number }}</a>
</ng-container>